module.exports = __webpack_public_path__ + "0961b7e3e8536fcd4cc983bf1de86a3c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/safari.png
 ** module id = 29
 ** module chunks = 0
 **/